import dynamic from 'next/dynamic';
export const CreditMattersTable = dynamic(() => import('./credit-matters-table'));